export const contact_slice_name = 'CONTACT';

export const contact_thunks = {
  CONTACT_FETCH_ADDRESS_LOOKUP_BY_POSTCODE: `${contact_slice_name}/fetchAddressLookupByPostcode`,
  CONTACT_FETCH_ADDRESS_LOOKUP_BY_ID: `${contact_slice_name}/fetchAddressLookupById`,
  CONTACT_FETCH_VALIDATE_EMAIL: `${contact_slice_name}/fetchValidateEmail`,
};

export const contact_phone_validation = /^(?:0\d{9,10}|\+[1-9]{2}[1-9]\d{9}|)$/;

export const contact_postcode_validation =
  /^([gG][iI][rR] 0[aA][aA])|((([a-zA-Z][0-9]{1,2})|(([a-zA-Z][[aA]-[A-Ha-hJ-Yj-y]][0-9]{1,2})|(([a-zA-Z][0-9][a-zA-Z])|([a-zA-Z][A-Ha-hJ-Yj-y][0-9]?[a-zA-Z]))))\s?[0-9][a-zA-Z]{2})$/;

export const contact_email_validation =
  /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
